import styled from 'styled-components';

/** 정산용/손익용 두 묶음을 색 띠로 구분한다. 범례의 스와치와 같은 값을 쓴다. */
const SETTLEMENT_TINT = '#f7f4ff';
const FINANCE_TINT = '#eef5fd';
const GROUP_BORDER = '#d8dee8';

export const FeeTableStyle = styled.div`
  .fee-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 32px;
    padding: 16px 24px;
    border-bottom: 1px solid #edf0f4;
    background: #fbfcfd;
    font-size: 13px;
    line-height: 1.6;
    color: var(--settings-muted);
  }
  .fee-legend-item {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    max-width: 520px;
  }
  .fee-legend-swatch {
    flex: 0 0 auto;
    width: 12px;
    height: 12px;
    margin-top: 4px;
    border-radius: 3px;
    border: 1px solid ${GROUP_BORDER};
  }
  .fee-legend-swatch.is-settlement {
    background: ${SETTLEMENT_TINT};
  }
  .fee-legend-swatch.is-finance {
    background: ${FINANCE_TINT};
  }
  .fee-legend b {
    color: var(--settings-text);
    font-weight: 600;
  }

  /* 그룹 색 띠 — 헤더부터 본문까지 같은 세로 블록으로 보이게 한다 */
  .fee-col-settlement {
    background: ${SETTLEMENT_TINT};
  }
  .fee-col-finance {
    background: ${FINANCE_TINT};
  }
  .fee-col-group-start {
    border-left: 1px solid ${GROUP_BORDER};
  }
  .fee-col-group-end {
    border-right: 1px solid ${GROUP_BORDER};
  }
  .ant-table-thead .fee-group-title {
    text-align: center;
    font-size: 12px;
    letter-spacing: 0.02em;
    color: var(--settings-muted);
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    background: #f7f8fa;
    font-weight: 600;
    font-size: 13px;
    color: var(--settings-text);
    border-bottom: 1px solid #e4e8ef;
  }
  .ant-table-wrapper .ant-table-thead > tr > th::before {
    display: none;
  }
  .ant-table-wrapper .ant-table-tbody > tr > td {
    padding: 10px 12px;
    border-bottom: 1px solid #f0f2f5;
  }
  .ant-table-wrapper .ant-table-thead > tr > th {
    padding: 11px 12px;
  }
  /* PG 사 칸은 세로 병합돼 여러 행을 덮는다 — 경계를 진하게 둬서 묶음이 보이게 */
  .ant-table-wrapper .ant-table-tbody > tr > td.fee-col-pg {
    vertical-align: middle;
    border-bottom: 1px solid #e4e8ef;
    background: #fff;
  }

  .fee-pg-name {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 13px;
  }
  .fee-method-name {
    font-size: 13px;
  }

  /* 휴면 조합은 지울 수 없지만 평소 건드릴 대상이 아니다 — 읽기 전용으로 둔다 */
  .fee-row-dormant .fee-pg-name,
  .fee-row-dormant .fee-method-name {
    color: #98a2b3;
    font-weight: 500;
  }
  .fee-row-dormant .ant-input-number-disabled .ant-input-number-input {
    color: #a7b0bd;
  }

  .fee-input {
    width: 100%;
  }
  .fee-input .ant-input-number-input {
    text-align: right;
    font-variant-numeric: tabular-nums;
  }
  .fee-input .ant-input-number-group-addon {
    min-width: 34px;
    padding: 0 8px;
    color: var(--settings-muted);
    font-size: 12px;
  }

  .fee-reverse-margin {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    font-size: 12px;
    color: #d6336c;
  }
`;
